"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Preferences_1 = __importDefault(require("chaire-lib-common/lib/config/Preferences"));
const interviewerModeMenuItem = {
    getText: (t) => Preferences_1.default.get('interviewMode', 'participant') === 'interviewer'
        ? t(['survey:ParticipantMode', 'main:ParticipantMode'])
        : t(['survey:InterviewerMode', 'main:InterviewerMode']),
    action: () => {
        const currentMode = Preferences_1.default.get('interviewMode', 'participant');
        const newMode = currentMode === 'participant' ? 'interviewer' : 'participant';
        Preferences_1.default.update({ interviewMode: newMode });
    }
};
const addInterviewerOptions = (config) => {
    const menuItems = config.userMenuItems || [];
    menuItems.push(interviewerModeMenuItem);
    config.userMenuItems = menuItems;
    // TODO Add specific monitoring for interviewers
    return config;
};
exports.default = addInterviewerOptions;
//# sourceMappingURL=interviewerSupport.js.map